export enum EmbeddingModel {
    Nomicembedtext = 'nomic-embed-text',
    Allminilm = 'all-minilm',
}
